import { useField } from "formik";
import { EfsMelcoEfsModelsSchemaListItem } from "melco-shared-logic";
import { Checkbox } from "melco-ui";
import { useCallback } from "react";

export const ToggleDataAssignmentVisibilityCheckbox: React.FC = () => {
  const [{ value: schema_list }, , { setValue }] =
    useField<EfsMelcoEfsModelsSchemaListItem[]>("schema_list");

  const dataAssignments = schema_list ?? [];

  const checkedCount = dataAssignments.filter((d) => d.show).length;
  const totalCount = dataAssignments.length;

  const checked = checkedCount > 0 && checkedCount === totalCount;
  const indeterminate = checkedCount > 0 && checkedCount < totalCount;

  const toggle = useCallback(() => {
    if (checked) {
      // uncheck all
      setValue(schema_list.map((d) => ({ ...d, show: false })));
    } else {
      // check all
      setValue(schema_list.map((d) => ({ ...d, show: true })));
    }
  }, [checked, indeterminate]);

  return (
    <Checkbox
      checked={checked}
      indeterminate={indeterminate}
      onChange={toggle}
    />
  );
};
